// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3-pQ1","fileBtn":"File_fileBtn__1wVpF","closeBtn":"File_closeBtn__3etJA","fileSelected":"File_fileSelected__5eOoJ","disabled":"File_disabled__2DvVI"};